import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle
} from 'react';
import { hex_md5 } from 'utils/md5';
import request from 'utils/request';
import config from 'config/Config';
import Util from 'utils';
import cacheManager from 'utils/cache/cacheManager';

// 保存原始的 createElement 方法
const originalCreateElement = React.createElement;
const originChildren = React.Children;

const LanguageContext = createContext();
const useLanguage = () => useContext(LanguageContext);
// 国际化配置Provider
const LanguageProvider = (props) => {
  const { children, ...rest } = props;

  return <LanguageContext.Provider {...rest}>{children}</LanguageContext.Provider>;
};

// 装饰器函数
const withTranslation = (Dom) => {
  return class WithTranslation extends React.Component {
    static contextType = LanguageContext;

    render() {
      return <Dom {...this.props} useContext={this.context} />;
    }
  };
};

const t = (text) => {
  return text;
};

// 翻译api函数
const translation = (text, save = true) => {
  const lng = window.currentLng || localStorage.getItem('lng');
  const translationJson = cacheManager.get(`translation_${lng}`) || {};

  if (window.currentLng == 'cn' || localStorage.getItem('lng') == 'cn') {
    return new Promise((resolve) => resolve(text));
  }
  if (translationJson[text]) {
    return new Promise((resolve) => resolve(translationJson[text]));
  }

  let params = {
    sign: hex_md5(text + 'yofoto333'),
    text,
    isSave: save ? 1 : 0
  };

  return new Promise((resolve) => {
    request({
      url: 'translate/record/translate',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      data: params
    }).then((res) => {
      const { data, resultCode } = res;
      try {
        if (resultCode == 0) {
          translationJson[text] = data.translateText;
          cacheManager.set(`translation_${lng}`, translationJson);
          resolve(data.translateText);
        } else {
          translationJson[text] = data.translateText;
          cacheManager.set(`translation_${lng}`, translationJson);
          resolve(text);
        }
      } catch (e) {
        resolve(text);
      }
    });
  });
};

// 翻译组件核心core
const transCore = (props) => {
  const { text, save, callback, otherParams = {} } = props;
  const lng = window.currentLng || localStorage.getItem('lng');
  const translationJson = cacheManager.get(`translation_${lng}`) || {};
  // 比对缓存中的json表 如果当前语言非中文 则请求接口翻译
  const langText = translationJson[text];
  if (langText && langText != text) {
    callback(langText, ...otherParams);
  } else if (text && window.currentLng != 'cn' && /[\u4e00-\u9fa5]/.test(text)) {
    translation(text, save).then((content) => {
      callback(content, ...otherParams);
    });
  } else {
    callback(text, ...otherParams);
  }
};

// 无法被拦截器处理到的string|reactNode处理
const translationByCallBack = (text, callback) => {
  if (window.currentLng == 'cn' || localStorage.getItem('lng') == 'cn') {
    callback(text);
  } else {
    if (typeof text == 'string') {
      if (/[\u4e00-\u9fa5]/.test(text)) {
        transCore({
          text: text,
          save: true,
          callback: (res) => callback(res)
        });
      } else {
        callback(text);
      }
    } else if (typeof text == 'object') {
      const children = text.props.children;
      if (Array.isArray(children)) {
        text.props.children = originChildren.map(children, (child) => {
          if (typeof child === 'string' && /[\u4e00-\u9fa5]/.test(child)) {
            return originalCreateElement(I18nText, {
              text: child,
              save: !text.props['data-unsave']
            });
          }
          return child;
        });
      }
      callback(text);
    }
  }
};

// 国际化语言-text
const I18nText = ({ text }) => {
  const [translationText, setTranslationText] = useState(text);

  useEffect(() => {
    transCore({ text, callback: setTranslationText });
  }, [text]);

  return translationText;
};

// 国际化语言-Input
const I18nInput = forwardRef(({ placeholder, ref, ...props }, refs) => {
  const [translationText, setTranslationText] = useState(placeholder);
  const inpurRef = useRef(null);
  useImperativeHandle(refs, () => inpurRef.current);

  useEffect(() => {
    transCore({ text: placeholder, callback: setTranslationText });
  }, [placeholder]);

  return originalCreateElement('input', { ...props, ref: inpurRef, placeholder: translationText });
});

// 国际化语言-TextArea
const I18nTextarea = forwardRef(({ placeholder, ref, ...props }, refs) => {
  const [translationText, setTranslationText] = useState(placeholder);
  const inpurRef = useRef(null);
  useImperativeHandle(refs, () => inpurRef.current);
  useEffect(() => {
    transCore({ text: placeholder, callback: setTranslationText });
  }, [placeholder]);

  return originalCreateElement('textarea', {
    ...props,
    ref: inpurRef,
    placeholder: translationText
  });
});

// 国际化语言-Toast提示
const ToastMessage = (toast) => {
  return (text, ...arg) => {
    transCore({ text, callback: toast, otherParams: arg });
  };
};
// 国际化语言目录
const Language_MAP = window.Language_MAP || {};

// 语言列表
const Language_List = window.Language_List || [];

export {
  LanguageProvider, // Provider组件
  LanguageContext, // context实例
  withTranslation, // 装饰器函数
  useLanguage, // hooks获取context实例
  originalCreateElement, // 保存原始的 createElement 方法
  originChildren,
  translation, // 翻译api函数
  translationByCallBack, // 无法被拦截器处理到的string|reactNode处理
  t, // mobx使用i18n实例
  transCore, // 翻译核心函数
  I18nText, // 翻译组件
  I18nInput, // 翻译组件
  I18nTextarea, // 翻译组件
  ToastMessage,
  Language_MAP, // 语言目录
  Language_List // 语言列表
};



// WEBPACK FOOTER //
// ./src/config/language/context.js